import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import css from './index.scss';

class SelectableListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: props.isChecked
        };
    }
    onSelection = (element) => {
        const checked = element.target.checked;
        this.setState({ isChecked: checked });
        this.props.onChange(element.target.id);
    }
    render() {
        const { id, name } = this.props;
        return (
            <div>
                <div className={css.info}>
                    <div className={css.checkbox}>
                        <input
                            checked={this.state.isChecked}
                            className={css.name}
                            id={id}
                            onChange={this.onSelection}
                            type="checkbox"
                        />
                        <label className={css.chklabel} htmlFor={id} />
                        <span className={css.description}>{name}</span>
                    </div>
                </div>
            </div>
        );
    }
}

SelectableListItem.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    isChecked: PropTypes.bool,
    onChange: PropTypes.func
};

export default injectIntl(SelectableListItem);



// WEBPACK FOOTER //
// ./app/components/selectable-list-item/index.js